import { render, staticRenderFns } from "./fp-food.vue?vue&type=template&id=4511e701&"
import script from "./fp-food.vue?vue&type=script&lang=js&"
export * from "./fp-food.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4511e701')) {
      api.createRecord('4511e701', component.options)
    } else {
      api.reload('4511e701', component.options)
    }
    module.hot.accept("./fp-food.vue?vue&type=template&id=4511e701&", function () {
      api.rerender('4511e701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/fp-food.vue"
export default component.exports